"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = void 0;
exports.LogLevel = Object.freeze({
    error: /** @type {"error"} */ "error", // message, c style arguments
    warn: /** @type {"warn"} */ "warn", // message, c style arguments
    info: /** @type {"info"} */ "info", // message, c style arguments
    log: /** @type {"log"} */ "log", // message, c style arguments
    debug: /** @type {"debug"} */ "debug", // message, c style arguments
});
